var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.08558 17.8C6.6039 18.2276 7.14446 18.6185 7.69785 19C8.25243 18.6236 8.79036 18.2232 9.31012 17.8C10.1766 17.0886 10.992 16.3172 11.7503 15.4915C13.4986 13.5799 15.3957 10.8086 15.3957 7.69785C15.3957 6.68695 15.1966 5.68596 14.8097 4.75201C14.4229 3.81806 13.8559 2.96946 13.141 2.25465C12.4262 1.53984 11.5776 0.972817 10.6437 0.585964C9.70974 0.199111 8.70874 0 7.69785 0C6.68695 0 5.68595 0.199111 4.75201 0.585964C3.81806 0.972817 2.96946 1.53984 2.25465 2.25465C1.53984 2.96946 0.972817 3.81806 0.585964 4.75201C0.199111 5.68596 -1.50635e-08 6.68695 0 7.69785C0 10.8086 1.89709 13.579 3.64536 15.4915C4.4037 16.3175 5.21911 17.0883 6.08558 17.8ZM7.69785 10.4776C6.9606 10.4776 6.25356 10.1848 5.73225 9.66345C5.21094 9.14214 4.91807 8.43509 4.91807 7.69785C4.91807 6.96061 5.21094 6.25356 5.73225 5.73225C6.25356 5.21094 6.9606 4.91807 7.69785 4.91807C8.43509 4.91807 9.14214 5.21094 9.66345 5.73225C10.1848 6.25356 10.4776 6.96061 10.4776 7.69785C10.4776 8.43509 10.1848 9.14214 9.66345 9.66345C9.14214 10.1848 8.43509 10.4776 7.69785 10.4776Z",
    fill: "url(#paint0_linear_26354_179450)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26354_179450",
    x1: 7.69785,
    y1: 0,
    x2: 7.69785,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A3A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EBED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerIcon);
export default __webpack_public_path__ + "static/media/markerIcon.d8bb9bdb1332ed458d5caa8517715276.svg";
export { ForwardRef as ReactComponent };